import { get } from './fetch';
import endpoints from '@src/config/endpoints';

export const systemLoginCall = () => {
  return get(endpoints.customer.systemLogin)
}

export default systemLoginCall;